import type { GQL_ID } from '@@partner:types:graphql'
import type { ProductStock } from '@@partner:types:app'

import React, { useCallback } from 'react'
import { Col, Grid, Panel } from 'rsuite'
import ProductStocksTable from '../form/stock/ProductStocksTable'
import type { ProductFormState } from '../types'
import { mergeLeftOnly } from 'merge-left-utils'

export interface ProductStockTabProps {
  formState: ProductFormState
  setFormState: React.Dispatch<React.SetStateAction<ProductFormState>>
  loadingProduct: boolean
}

export default function ProductStockTab ({
  formState,
  setFormState,
  loadingProduct
}: ProductStockTabProps) {
  const handleProductStocksChange = useCallback(
    ({ stocks, useSingleStock, singleStock }: any) => {
      setFormState((state) =>
        mergeLeftOnly([ 'singleStock', 'useSingleStock', 'stocks' ], state, {
          singleStock: Number(singleStock),
          useSingleStock,
          stocks: stocks.map((stock: any) => ({
            ...stock,
            amount: Number(stock.amount)
          }))
        })
      )
    },
    [ setFormState ]
  )

  const handleProductShopsChange = useCallback(
    (shop_ids: GQL_ID[]) => {
      setFormState((state) => mergeLeftOnly([ 'shop_ids' ], state, { shop_ids }))
    },
    [ setFormState ]
  )

  return (
    <Grid fluid className="my-5">
      <Col xs={24}>
        <Panel shaded header="Остатки">
          <ProductStocksTable
            loadingProduct={loadingProduct}
            stocks={formState.stocks}
            shopIds={formState.shop_ids}
            onChange={handleProductStocksChange}
            onShopSelect={handleProductShopsChange}
          />
        </Panel>
      </Col>
    </Grid>
  )
}
